// Dashboard components
import MDButton from "components/MDButton";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

const VendorButton = ({ onClick, disabled, tooltip, ...props }) => {
  return (
    <Tooltip title={tooltip}>
      <MDButton
        onClick={onClick}
        disabled={disabled}
        variant="contained"
        type="button"
        {...props}
        color={props?.style?.backgroundColor ? null : "error"}
        sx={{
          minWidth: "140px", // increase button width
          padding: "6px 16px", // adjust padding
          ...props.sx, // merge any additional sx from props
        }}
      >
        Add Supplier
        <Icon sx={{ ml: 1 }}>add</Icon> {/* adds small margin-left to icon */}
      </MDButton>
    </Tooltip>
  );
};

export default VendorButton;
